import { render, staticRenderFns } from "./CheckSocial.vue?vue&type=template&id=38e0a4a6&lang=pug&"
import script from "./CheckSocial.vue?vue&type=script&lang=js&"
export * from "./CheckSocial.vue?vue&type=script&lang=js&"
import style0 from "./CheckSocial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports